<template>
  <div class="sideMenu" :class="{'sidemenu-open':sideMenuOpen,'sidemenu-close':!sideMenuOpen}">
    <div class="sidebar-overlay" @click="closeMenu"></div>
    <div class="sidebar-content">
      <router-link to="/dashboard" class="logo-container">
        <img class="logo-img" src="/logo-white.png" alt="Goldylocks">
      </router-link>
      
      <a @click="closeMenu" class="menu-close-button is-hidden-tablet">
        <i class="fas fa-times"></i>
      </a>
      
      <nav class="menus">
        <p class="menu-category">Menu</p>
        
        <router-link 
          to="/dashboard" 
          class="menu-item"
          :class="{'active':currentPage==='Dashboard'}"
        >
          <span class="menu-icon"><i class="fas fa-th-large"></i></span>
          <span class="menu-text">Dashboard</span>
        </router-link>
        
        <router-link 
          to="/companies" 
          class="menu-item"
          :class="{'active':currentPage==='Companies'}"
        >
          <span class="menu-icon"><i class="fas fa-stream"></i></span>
          <span class="menu-text">Aplicações</span>
        </router-link>
        
        <!-- Reseller Menu -->
        <template v-if="isReseller">
          <p class="menu-category mt-6">Revenda</p>
          <router-link 
            to="/companies/create" 
            class="menu-item"
            :class="{'active':currentPage==='CreateCompanyForm'}"
          >
            <span class="menu-icon"><i class="fas fa-plus"></i></span>
            <span class="menu-text">Criar Goldylocks</span>
          </router-link>
          <router-link 
            to="/resellercompanies" 
            class="menu-item"
            :class="{'active':currentPage==='ResellerCompanies'}"
          >
            <span class="menu-icon"><i class="fas fa-user-friends"></i></span>
            <span class="menu-text">Os meus clientes</span>
          </router-link>
        </template>
        
        <!-- Accountant Menu -->
        <template v-if="isAccountant">
          <p class="menu-category mt-6">Contabilidade</p>
          <router-link 
            to="/companies/create" 
            class="menu-item"
            :class="{'active':currentPage==='CreateCompanyForm'}"
          >
            <span class="menu-icon"><i class="fas fa-plus"></i></span>
            <span class="menu-text">Criar Goldylocks</span>
          </router-link>
          <router-link 
            to="/accountantcompanies" 
            class="menu-item"
            :class="{'active':currentPage==='AccountantCompanies'}"
          >
            <span class="menu-icon"><i class="fas fa-briefcase"></i></span>
            <span class="menu-text">Empresas</span>
          </router-link>
        </template>
        
        <!-- Account Section -->
        <div class="account-section">
          <p class="menu-category mt-6">Conta</p>
          <p class="profile-name">{{ userData.email }}</p>
          
          <router-link 
            to="/profile" 
            class="menu-item"
            :class="{'active':currentPage==='Profile'}"
          >
            <span class="menu-icon"><i class="fa fa-user-alt"></i></span>
            <span class="menu-text">Os meus dados</span>
          </router-link>
          
          <a @click="logout" href="#" class="menu-item link-logout">
            <span class="menu-icon"><i class="fas fa-sign-out-alt"></i></span>
            <span class="menu-text">Terminar sessão</span>
          </a>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideMenu",
  computed: {
    currentPage() {
      return this.$store.getters.currentPage;
    },
    userData() {
      return this.$store.getters.userData;
    },
    isReseller() {
      return this.userData.type === "2" || this.userData.type === "1"
    },
    isAccountant() {
      return this.userData.type === "3"
    },
    sideMenuOpen() {
      return this.$store.getters.sideMenuOpen;
    }
  },
  methods: {
    closeMenu() {
      this.$store.commit('toggleMenu');
    },
    logout() {
      this.$store.dispatch('clearSearchFilter');
      this.$store.dispatch('clearData');
      localStorage.clear();
      this.$router.push('/login');
    }
  },
  watch: {
    '$route'(page) {
      this.closeMenu();
      this.$store.commit('currentPage', page.name);
    }
  },
  mounted() {
    this.$store.dispatch('getUserData');
  }
}
</script>

<style scoped>
.sideMenu {
  height: 100%;
  width: var(--sidebar-width);
  background: var(--sidebar-bg);
  position: relative;
  z-index: 100;
}

.sidebar-overlay {
  display: none;
}

.sidebar-content {
  height: 100%;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.logo-container {
  display: block;
  text-align: center;
  padding: 0 20px 24px;
}

.logo-img {
  height: 40px;
  width: auto;
}

.menu-close-button {
  display: none;
}

.menus {
  flex: 1;
  padding: 0 12px;
}

.menu-category {
  color: var(--text-muted);
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  padding: 0 12px;
  margin-bottom: 8px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  color: #94A3B8;
  text-decoration: none;
  border-radius: var(--radius-md);
  margin-bottom: 4px;
  transition: all var(--transition-base);
  position: relative;
}

.menu-item:hover {
  background: var(--sidebar-hover);
  color: #E2E8F0;
}

.menu-item.active {
  background: var(--sidebar-active);
  color: #fff;
}

.menu-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 24px;
  background: var(--primary);
  border-radius: 0 2px 2px 0;
}

.menu-icon {
  width: 24px;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.menu-text {
  font-size: 0.9rem;
  font-weight: 500;
}

.profile-name {
  color: #94A3B8;
  font-size: 0.75rem;
  padding: 0 16px;
  margin-bottom: 12px;
  word-break: break-all;
}

.link-logout {
  color: #FCA5A5;
}

.link-logout:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #FCA5A5;
}

.account-section {
  margin-top: auto;
  padding-bottom: 20px;
}

/* Mobile Styles */
@media only screen and (max-width: 768px) {
  .sideMenu {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    box-shadow: var(--shadow-xl);
  }
  
  .sidemenu-close {
    transform: translateX(-100%);
    transition: transform var(--transition-slow);
  }
  
  .sidemenu-open {
    transform: translateX(0);
    transition: transform var(--transition-slow);
  }
  
  .sidebar-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .menu-close-button {
    display: block;
    position: absolute;
    top: 16px;
    right: 16px;
    color: #94A3B8;
    font-size: 1.25rem;
    padding: 8px;
    cursor: pointer;
    z-index: 10;
  }
  
  .menu-close-button:hover {
    color: #fff;
  }
}
</style>
